import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { RmaResponse } from '@rma/dashboard/generic/util/http';
import { ProfileType } from '@rma/generic/domain/types';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { UserNotification } from '..';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private readonly http = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getNextNotification(profileType: ProfileType, profileCode: string): Observable<UserNotification> {
    const uri = this.rmaApiUrl(`Notifications/${profileType}/${profileCode}/GetNextNotification`);
    return this.http.get<UserNotification>(uri, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public dismissNotification(notificationId: number): Observable<RmaResponse> {
    const uri = this.rmaApiUrl('Account/UserNotificationDismissed');
    return this.http.post<RmaResponse>(uri, { UserNotificationId: notificationId }, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public actionNotification(notificationId: number): Observable<RmaResponse> {
    const uri = this.rmaApiUrl('Account/UserNotificationActioned');
    return this.http.post<RmaResponse>(uri, { UserNotificationId: notificationId }, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
